export default "__VITE_ASSET__DeFgDhp7__"